import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import GradientButton from "../../../../Core/GradientButton";
import AlertModal from "../../../../Core/AlertModal";
import { useSessionStore } from "../../../../../Stores/SessionStore";

const deleteAccountMessage =
	"Are you sure you want to delete your account?\n\n" +
	"The following personal information will be removed or anonymized:\n" +
	"• Your name\n" +
	"• Your email address\n" +
	"• Your phone number\n" +
	"• Your login credentials and PIN\n" +
	"• Your ID number\n" +
	"• Your saved profile documents\n" +
	"• Your linked device access\n\n" +
	"We retain transaction records for 5 years as required by local tax laws.\n\n" +
	"This action cannot be undone.";

export default function DeleteAccountModal({ show, onClose }) {
	const store = useSessionStore();
	const navigate = useNavigate();
	const [deleting, setDeleting] = useState(false);
	const [error, setError] = useState(null);
	const [successAlert, setSuccessAlert] = useState(null);

	async function handleConfirmDelete() {
		setError(null);
		setDeleting(true);
		const result = await store.CustomersService.DeleteOwnAccount();
		setDeleting(false);

		if (result?.Success) {
			onClose();
			setSuccessAlert({
				show: true,
				success: true,
				title: "Account Deleted",
				message: "Your account has been deleted successfully.",
				onClose: async () => {
					setSuccessAlert(null);
					await store.Logout();
					navigate("/");
				},
			});
			return;
		}

		setError(result?.Message ?? "Unable to delete your account.");
	}

	return (
		<>
			<Modal show={show} onHide={onClose} size="lg">
				<Modal.Header>
					<h3>Delete Account</h3>
				</Modal.Header>
				<Modal.Body>
					<p style={{ whiteSpace: "pre-line" }}>{deleteAccountMessage}</p>
					{error && <small className="text-danger d-block mt-3">{error}</small>}
				</Modal.Body>
				<Modal.Footer className="d-flex flex-column gap-2">
					<GradientButton
						title={deleting ? "Deleting Account..." : "Delete Account"}
						variant="red"
						onClick={handleConfirmDelete}
						disabled={deleting}
						loading={deleting}
					/>
					<GradientButton title="Cancel" variant="yellowOrange" onClick={onClose} disabled={deleting} />
				</Modal.Footer>
			</Modal>
			{successAlert && <AlertModal modal={successAlert} />}
		</>
	);
}
